"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    StickyContainer: function() {
        return StickyContainer;
    },
    StickyContainerWithRef: function() {
        return StickyContainerWithRef;
    },
    nextTop: function() {
        return nextTop;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _StickyContext = require("./StickyContext");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const getMarginHeight = (el)=>{
    try {
        const styles = window.getComputedStyle(el);
        return parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    } catch (e) {
        // can't really recover.
        return 0;
    }
};
const nextTop = (stack, param)=>{
    let { shouldStack } = param;
    var _lastNonStackingEl_ref;
    const lastNonStackingEl = stack.filter((item)=>!item.stack).pop();
    if ((lastNonStackingEl === null || lastNonStackingEl === void 0 ? void 0 : (_lastNonStackingEl_ref = lastNonStackingEl.ref) === null || _lastNonStackingEl_ref === void 0 ? void 0 : _lastNonStackingEl_ref.current) == null) {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        return -1;
    }
    if (shouldStack) {
        return lastNonStackingEl.top;
    } else {
        const innerHeight = lastNonStackingEl.ref.current.getBoundingClientRect().height;
        const marginHeight = getMarginHeight(lastNonStackingEl.ref.current);
        return lastNonStackingEl.top + innerHeight + marginHeight;
    }
};
const StickyContainerWithRef = (param)=>{
    let { children, useIframeViewport = false, ref } = param;
    const stack = (0, _react.useRef)([]);
    (0, _react.useEffect)(()=>{
        if (useIframeViewport) {
            var _window_frameElement;
            var _window_frameElement_contentDocument;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            const refEl = (_window_frameElement_contentDocument = (_window_frameElement = window.frameElement) === null || _window_frameElement === void 0 ? void 0 : _window_frameElement.contentDocument) !== null && _window_frameElement_contentDocument !== void 0 ? _window_frameElement_contentDocument : undefined;
            if (ref != null) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                ref.current = refEl;
            }
        }
    }, [
        useIframeViewport,
        ref
    ]);
    const push = (0, _react.useCallback)((itemRef, opts)=>{
        const item = {
            ref: itemRef,
            top: nextTop(stack.current, opts),
            stack: opts.shouldStack
        };
        stack.current.push(item);
        return item;
    }, [
        stack
    ]);
    const pop = (0, _react.useCallback)((itemRef)=>{
        const index = stack.current.findIndex((item)=>item.ref === itemRef);
        if (index >= 0) {
            stack.current.splice(index, 1);
        }
    }, [
        stack
    ]);
    return /*#__PURE__*/ _react.default.createElement(_StickyContext.StickyContext.Provider, {
        value: {
            push,
            pop,
            stack,
            rootRef: ref !== null && ref !== void 0 ? ref : null
        }
    }, children);
};
const StickyContainer = (param)=>{
    let { children, useIframeViewport } = param;
    const rootRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ _react.default.createElement(StickyContainerWithRef, {
        ref: rootRef,
        useIframeViewport: useIframeViewport
    }, typeof children === "function" ? children({
        ref: rootRef
    }) : children);
};

//# sourceMappingURL=StickyContainer.js.map